import { Component, OnInit } from '@angular/core';
import { logbaseService } from "../../services/logbase.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from "@ngx-translate/core";


@Component({
  selector: 'app-po-exports',
  templateUrl: './po-exports.component.html',
  styleUrls: ['./po-exports.component.scss']
})
export class PoExportsComponent implements OnInit {
  exportTwodata: any;
  dd: number;
  MM: number;
  yyyy: number;
  exportOne: any;
  exportOneData: any;
  exportTwo: any;
  constructor(private logbaseService: logbaseService, private toastr: ToastrService, private translate: TranslateService) { }

  ngOnInit() {
    this.getExport1Data();
    this.getdate();
    this.getExport2Data();
  }

  getdate() {
    var today = new Date();
    this.yyyy = today.getUTCFullYear();
    this.MM = today.getUTCMonth() + 1;
    this.dd = today.getUTCDate();
  }

  getExport1Data() {
    this.logbaseService.getExport1Data().subscribe(
      result => {
        this.exportOne = result;
        this.exportOneData = this.exportOne.response;
      }
    )
  };

  getExport2Data() {
    this.logbaseService.getExport2Data().subscribe(
      result => {
        this.exportTwo = result;
        this.exportTwodata = this.exportTwo.response;
      });

  }

  export2Download() {
    if (this.exportTwodata !== null) {
      window.location.href = this.exportTwodata.blobUrl;
    }
    else if (this.exportTwodata == null) {
      this.toastr.error(this.translate.instant('NO_FILE_AVAILABLE_TODAY'));
    }
  }

  downloadFile(data) {
    // const blob = new Blob([data], { type: 'text/csv' });
    // const url= window.URL.createObjectURL(blob);
    var strWindowFeatures = "directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,addressbar=no,resizable=no,width=400,height=350";
    // window.open(data,'',strWindowFeatures);
    window.location.href = data;
  }

}
